import { render, staticRenderFns } from "./EventsDayWidgetServer.vue?vue&type=template&id=0e925abd"
import script from "./EventsDayWidgetServer.vue?vue&type=script&lang=js"
export * from "./EventsDayWidgetServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports